import axios from 'axios';

const addProductToFavApi = async (values, token, langIsoCode, edit = false) => {
  try {
    const res = await axios.post('Favourite/addOrRemove', values, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default addProductToFavApi;
